export default __webpack_public_path__ + "static/media/kliznekapije3.0bf6fdd2.png";